import React from "react";
import { expData } from "../../data/Experiences";
import TitleButton from "../Title Button/TitleButton";

const splitMeta = (value) => {
  const [primary, secondary = ""] = value.split(" | ");
  return { primary, secondary };
};

function ExperienceRow({ data, index }) {
  const { primary: companyName, secondary: employmentType } = splitMeta(
    data.company_name,
  );
  const { primary: dateRange, secondary: duration } = splitMeta(data.date);
  const { primary: location, secondary: workMode } = splitMeta(data.location);

  return (
    <div className='grid grid-cols-1 gap-x-10 gap-y-6 border-b border-line py-12 lg:grid-cols-12 lg:items-start'>
      {/* Index + dates */}
      <div className='flex items-baseline gap-4 lg:col-span-3 lg:flex-col lg:gap-3'>
        <span className='font-heading text-3xl font-bold tabular-nums text-primary/25'>
          {String(index + 1).padStart(2, "0")}
        </span>
        <div>
          <p className='font-body text-sm font-medium text-primary/70'>
            {dateRange}
          </p>
          {duration && (
            <p className='mt-1 font-body text-2xs uppercase tracking-widest text-primary/40'>
              {duration}
            </p>
          )}
        </div>
      </div>

      {/* Role + company */}
      <div className='lg:col-span-6'>
        <h3 className='font-heading text-2xl font-bold leading-tight tracking-tight text-primary md:text-3xl'>
          {data.position_name}
        </h3>
        <p className='mt-3 flex flex-wrap items-center gap-2 font-body text-sm text-primary/60'>
          <span className='font-medium text-primary/80'>{companyName}</span>
          {employmentType && (
            <>
              <span className='h-1 w-1 bg-primary/30' />
              <span className='text-primary/50'>{employmentType}</span>
            </>
          )}
        </p>
        <p className='mt-1 font-body text-sm text-primary/45'>
          {location}
          {workMode && ` — ${workMode}`}
        </p>

        {/* Tags */}
        <div className='mt-5 flex flex-wrap gap-x-4 gap-y-1.5'>
          {(data.tags || []).map((tag) => (
            <span key={tag} className='font-body text-xs text-primary/55'>
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Logo */}
      <div className='lg:col-span-3 lg:flex lg:justify-end'>
        <div className='flex h-16 w-16 items-center justify-center border border-line bg-secondary p-3'>
          <img
            src={data.image}
            alt={companyName}
            className='h-full w-full object-contain grayscale'
          />
        </div>
      </div>
    </div>
  );
}

function Experience() {
  return (
    <section
      id='exp'
      className='w-full border-b border-line bg-background py-20 md:py-28'
    >
      <div className='swiss-container'>
        <TitleButton title={"Experience"} number={"04"} />

        {/* Headline */}
        <div className='mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end'>
          <h2 className='font-heading text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-primary sm:text-4xl md:text-5xl lg:col-span-8'>
            Professional
            <br />
            <span className='text-primary/55'>journey</span>
          </h2>
          <p className='font-body text-sm leading-relaxed text-primary/55 md:text-base lg:col-span-4'>
            Roles that shaped my craft from marketing automation systems to
            mobile applications.
          </p>
        </div>

        {/* Rows */}
        <div className='mt-16 border-t border-primary/60'>
          {expData.map((data, index) => (
            <ExperienceRow key={index} data={data} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
